export default class ProductUtils {
  constructor() {}

  private static clearFullContent(target: HTMLDivElement) {
    if (target.classList.contains("visible")) {
      target.classList.remove("visible");
    }
  }

  private static toggleFullContent(target: HTMLDivElement) {
    if (target.classList.contains("visible")) {
      target.classList.remove("visible");
    } else {
      target.classList.add("visible");
    }
  }

  static addReadmoreHandler(triggerId: string, targetId: string) {
    const linkButton: HTMLAnchorElement = document.querySelector(triggerId);
    const target: HTMLDivElement = document.querySelector(targetId);

    if (linkButton && target) {
      this.clearFullContent(target);
      linkButton.addEventListener("click", (e: MouseEvent) => {
        e.preventDefault();
        this.toggleFullContent(target);
      });
    }
  }
}
